import { create } from 'zustand';

export interface DialogueView {
  text: string;
  speaker?: string;
  portraitId?: string;
  /** When set, the line auto-dismisses after this delay (no input). */
  durationMs?: number;
}

export interface ShowcaseView {
  label: string;
  sprite: string;
}

interface CinematicState {
  active: boolean;
  dialogue: DialogueView | null;
  showcase: ShowcaseView | null;
}

interface CinematicActions {
  setActive: (v: boolean) => void;
  setDialogue: (d: DialogueView | null) => void;
  setShowcase: (s: ShowcaseView | null) => void;
}

export const useCinematicStore = create<CinematicState & CinematicActions>(
  (set) => ({
    active: false,
    dialogue: null,
    showcase: null,
    setActive: (v) => set({ active: v }),
    setDialogue: (d) => set({ dialogue: d }),
    setShowcase: (s) => set({ showcase: s }),
  }),
);
